var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      directives: [
        {
          name: "track",
          rawName: "v-track:click",
          value: { axId: _vm.axId, axType: _vm.axType, axExtra: _vm.axExtra },
          expression: "{ axId: axId, axType: axType, axExtra: axExtra }",
          arg: "click"
        }
      ],
      staticClass: "btn-login",
      attrs: {
        href: _vm.$router.resolve({ name: "account_login", hash: "#login" })
          .href,
        rel: "nofollow",
        "data-testid": "main_login_button"
      },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.$store.dispatch("signupModal/login")
        }
      }
    },
    [_vm._t("default", [_vm._v(_vm._s(_vm.text))])],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }